var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 26,
    viewBox: "0 0 92 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9197 0H28.1517V25.9997H23.9197V0Z",
    fill: "#17313B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8718 17.7608C42.8718 21.7889 39.5598 22.1551 38.4558 22.1551C35.8798 22.1551 35.5118 19.7748 35.5118 18.4932V8.42285H31.2798V18.3101C31.2798 20.6903 32.0158 22.8875 33.4878 24.1691C34.7758 25.4508 36.4318 26.0001 38.4558 26.0001C39.9278 26.0001 41.7678 25.6339 42.8718 24.5353V26.0001H47.1038V8.42285H42.8718V17.7608Z",
    fill: "#17313B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3839 2.01367H51.1519V8.42205H48.0239V12.4502H51.1519V25.9993H55.3839V12.4502H58.5119V8.42205H55.3839V2.01367Z",
    fill: "#17313B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7601 20.6893C70.8401 21.4217 69.5521 21.971 68.2641 21.971C65.3201 21.971 63.296 19.7738 63.296 16.8443C63.296 13.9147 65.3201 11.9007 68.2641 11.9007C69.5521 11.9007 70.8401 12.2669 71.7601 13.1824L72.3121 13.7316L75.2561 10.9852L74.5201 10.4359C72.8641 8.97114 70.6561 8.05566 68.2641 8.05566C63.1121 8.05566 59.248 11.9007 59.248 17.0274C59.248 22.1541 63.1121 25.9991 68.2641 25.9991C70.6561 25.9991 72.8641 25.0836 74.5201 23.6189L75.2561 23.0696L72.3121 20.14L71.7601 20.6893Z",
    fill: "#17313B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.16 9.88721C88.872 8.60553 87.584 8.05624 85.56 8.05624C84.088 8.05624 82.616 8.42243 81.512 9.52101V0H77.28V25.9997H81.512V16.2956C81.512 12.2675 84.272 11.9013 85.376 11.9013C87.952 11.9013 87.768 14.2815 87.768 15.5632V25.8166H92V15.7463C92 13.366 91.448 11.1689 90.16 9.88721Z",
    fill: "#17313B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0797 19.9577C69.7057 19.9577 71.0237 18.6461 71.0237 17.0282C71.0237 15.4102 69.7057 14.0986 68.0797 14.0986C66.4538 14.0986 65.1357 15.4102 65.1357 17.0282C65.1357 18.6461 66.4538 19.9577 68.0797 19.9577Z",
    fill: "#EF4335"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.032 19.5914C16.56 21.0562 14.352 21.9717 11.96 21.9717C7.36 21.9717 4.048 18.3097 4.048 13.3661C4.048 8.42253 7.36 4.76061 12.144 4.76061C14.352 4.76061 16.56 5.67609 18.216 7.32395L18.768 7.87324L21.528 5.1268L20.976 4.57751C18.584 2.19725 15.456 0.91558 12.144 0.91558C5.152 0.732483 0 6.22538 0 13.3661C0 20.5069 5.152 25.9998 11.96 25.9998C15.272 25.9998 18.584 24.7181 20.792 22.3379L21.344 21.7886L18.584 19.0421L18.032 19.5914Z",
    fill: "#17313B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.cc601312052833d059546ff047bc4786.svg";
export { ForwardRef as ReactComponent };